import { inject } from '@angular/core';
import { IHttpOptions } from '@partners/http';
import { isEmptyObject } from '@partners/utils';
import { CatalogService } from '../services/catalog.service';

export const financeCatalogGuard = async (options: IHttpOptions = {}): Promise<boolean> => {
  const catalogService = inject(CatalogService);
  const financeCatalog = await catalogService.loadFinance(options);
  return !isEmptyObject(financeCatalog);
};
